/* Light YouTube Embeds by @labnol */
/* Web: http://labnol.org/?p=27941 */

export function initYT() {
    var divs = document.querySelectorAll(".youtube-player");

    for (var i = 0; i < divs.length; i++) {
        var div = divs[i];
        var videoId = div.dataset.id;

        var thumbSrc = 'https://i.ytimg.com/vi/' + videoId + '/hqdefault.jpg';
        var thumb = '<img src="' + thumbSrc + '">';
        var play = '<div class="play"></div>';

        div.innerHTML = thumb + play;
        div.onclick = labnolIframe;
    }
}

function labnolIframe() {
    var videoId = this.dataset.id;

    var iframe = document.createElement("iframe");
    var embed = "https://www.youtube.com/embed/" + videoId + "?autoplay=1";

    iframe.setAttribute("src", embed);
    iframe.setAttribute("frameborder", "0");
    iframe.setAttribute("allowfullscreen", "1");

    var cardElement = findParentWithClass(this, 'card');
    
    if (cardElement) {
        cardElement.classList.add('active-list');
    }

    this.parentNode.replaceChild(iframe, this);
    this.parentNode.classList.add('active-video');
}

// Helper function to find the parent element with a specific class
function findParentWithClass(element, className) {
    while ((element = element.parentElement) && !element.classList.contains(className));
    return element;
}